import React, { createContext, useState, useEffect } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
const NavbarContext = createContext({
    isDark: false,
    logoUrl: '/',
    hideLogo: false,
    navItems: [],
    setNavItems: () => null,
    userMenuItems: [],
    setUserMenuItems: () => null,
    notificationMenuItems: [],
    setNotificationMenuItems: () => null,
    helpUrl: '',
    setHelpUrl: () => null,
    helpTarget: '',
    setHelpTarget: () => null,
    helpMenuItems: [],
    setHelpMenuItems: () => null,
    location: '',
    setLocation: () => null,
    helpMenuLocation: '',
    setHelpMenuLocation: () => null,
    userMenuLocation: '',
    setUserMenuLocation: () => null,
    showAlertIconBadge: false,
    setShowAlertIconBadge: () => null,
    notificationItemFormatter: () => null,
    setNotificationItemFormatter: () => null,
    noNotificationMessage: '',
    setNoNotificationMessage: () => null,
    hasBody: false,
    setHasBody: () => null,
    hasAdditionalNavItems: false,
    setHasAdditionalNavItems: () => null,
    hasNotificationMenu: false,
    setHasNotificationMenu: () => null,
    navbarLinkWrapper: null,
    setNavbarLinkWrapper: () => null,
    helpItemLinkWrapper: undefined,
    setHelpItemLinkWrapper: () => null,
    helpDropdownItemLinkWrapper: undefined,
    setHelpDropdownItemLinkWrapper: () => null,
    userMenuLinkWrapper: undefined,
    setUserMenuLinkWrapper: () => null,
    notificationMenuLinkWrapper: undefined,
    setNotificationMenuLinkWrapper: () => null,
    userInfo: null,
    setUserInfo: () => null,
    dropdownsExpandedByDefault: false,
    setDropdownsExpandedByDefault: () => null,
    appSwitcherItems: [],
    setAppSwitcherItems: () => null,
    showMobileMenu: false,
    setShowMobileMenu: () => null,
    showMobileNotifications: false,
    setShowMobileNotifications: () => null,
    showMobileApplicationSwitcher: false,
    setShowMobileApplicationSwitcher: () => null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    notificationMenuOnClick: () => { },
    setNotificationMenuOnClick: () => null,
    customMobileMenu: null,
    hideHelpMenuHeader: false,
    setHideHelpMenuHeader: () => null,
    appInstancesOpen: [],
    setAppInstancesOpen: () => null,
    appSwitcherLinkWrapper: undefined,
    setAppSwitcherLinkWrapper: () => null,
    launchpadUrl: '',
    setLaunchpadUrl: () => null
});
NavbarContext.Consumer;
const NavbarProvider = ({ children, isDark, logoUrl, hideLogo, customMobileMenu, isMobileMenuOpen, onMobileMenuToggle }) => {
    const [navItems, setNavItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState('');
    const [helpTarget, setHelpTarget] = useState('');
    const [helpMenuItems, setHelpMenuItems] = useState([]);
    const [userMenuItems, setUserMenuItems] = useState([]);
    const [appSwitcherItems, setAppSwitcherItems] = useState([]);
    const [location, setLocation] = useState('');
    const [helpMenuLocation, setHelpMenuLocation] = useState('');
    const [userMenuLocation, setUserMenuLocation] = useState('');
    const [notificationMenuItems, setNotificationMenuItems] = useState(null);
    const [showAlertIconBadge, setShowAlertIconBadge] = useState(false);
    const [showMobileNotifications, setShowMobileNotifications] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(isMobileMenuOpen);
    const [showMobileApplicationSwitcher, setShowMobileApplicationSwitcher] = useState(false);
    const [notificationItemFormatter, setNotificationItemFormatter] = useState(null);
    const [noNotificationMessage, setNoNotificationMessage] = useState('');
    const [hasBody, setHasBody] = useState(false);
    const [hasAdditionalNavItems, setHasAdditionalNavItems] = useState(false);
    const [hasNotificationMenu, setHasNotificationMenu] = useState(false);
    const [navbarLinkWrapper, setNavbarLinkWrapper] = useState(null);
    const [helpItemLinkWrapper, setHelpItemLinkWrapper] = useState(null);
    const [helpDropdownItemLinkWrapper, setHelpDropdownItemLinkWrapper] = useState(null);
    const [notificationMenuLinkWrapper, setNotificationMenuLinkWrapper] = useState(null);
    const [userMenuLinkWrapper, setUserMenuLinkWrapper] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [dropdownsExpandedByDefault, setDropdownsExpandedByDefault] = useState(false);
    const [notificationMenuOnClick, setNotificationMenuOnClick] = useState(null);
    const [hideHelpMenuHeader, setHideHelpMenuHeader] = useState(false);
    const [appInstancesOpen, setAppInstancesOpen] = useState([]);
    const [appSwitcherLinkWrapper, setAppSwitcherLinkWrapper] = useState(null);
    const [launchpadUrl, setLaunchpadUrl] = useState('');
    useEffect(() => {
        setShowMobileMenu(isMobileMenuOpen);
    }, [isMobileMenuOpen]);
    useEffect(() => {
        onMobileMenuToggle && onMobileMenuToggle(showMobileMenu);
    }, [showMobileMenu]);
    return (React.createElement(NavbarContext.Provider, { value: {
            isDark,
            logoUrl,
            hideLogo,
            navItems,
            setNavItems,
            userMenuItems,
            setUserMenuItems,
            notificationMenuItems,
            setNotificationMenuItems,
            helpUrl,
            setHelpUrl,
            helpTarget,
            setHelpTarget,
            helpMenuItems,
            setHelpMenuItems,
            location,
            setLocation,
            helpMenuLocation,
            setHelpMenuLocation,
            userMenuLocation,
            setUserMenuLocation,
            showAlertIconBadge,
            setShowAlertIconBadge,
            notificationItemFormatter,
            setNotificationItemFormatter,
            noNotificationMessage,
            setNoNotificationMessage,
            hasBody,
            setHasBody,
            hasAdditionalNavItems,
            setHasAdditionalNavItems,
            hasNotificationMenu,
            setHasNotificationMenu,
            userMenuLinkWrapper,
            setUserMenuLinkWrapper,
            helpItemLinkWrapper,
            setHelpItemLinkWrapper,
            helpDropdownItemLinkWrapper,
            setHelpDropdownItemLinkWrapper,
            navbarLinkWrapper,
            setNavbarLinkWrapper,
            notificationMenuLinkWrapper,
            setNotificationMenuLinkWrapper,
            userInfo,
            setUserInfo,
            dropdownsExpandedByDefault,
            setDropdownsExpandedByDefault,
            appSwitcherItems,
            setAppSwitcherItems,
            showMobileMenu,
            setShowMobileMenu,
            showMobileNotifications,
            setShowMobileNotifications,
            showMobileApplicationSwitcher,
            setShowMobileApplicationSwitcher,
            notificationMenuOnClick,
            setNotificationMenuOnClick,
            customMobileMenu,
            hideHelpMenuHeader,
            setHideHelpMenuHeader,
            appInstancesOpen,
            setAppInstancesOpen,
            appSwitcherLinkWrapper,
            setAppSwitcherLinkWrapper,
            launchpadUrl,
            setLaunchpadUrl
        } }, children));
};

export { NavbarContext, NavbarProvider };
//# sourceMappingURL=NavbarContext.js.map
